export const TTS_SID = '34502';
